<template>
    <div :class="['messageBoardContainer',accessType=='pc'?'messageBody':'']" v-loading.fullscreen.lock="fullscreenLoading">
        <div v-if="hasBack" class="headerTip">
            <img :src="delPng" style="position:absolute;left:.4522rem;cursor:pointer;width: .28rem;top: 0.8rem;" @click="goBack">
            <div>请您留言</div>
        </div>
        <p class="title">您好，很抱歉未及时为您提供服务，您可发送留言消息，人工客服看到后会给您回复消息。</p>
        <el-form ref="form" :model="form" label-width="2.262rem" :rules="rules" class="demo-ruleForm">
            <el-form-item label="手机号码:" prop="phone">
                <el-row>
                    <el-col :span="24" style="padding-right: 0">
                        <el-input v-model="form.phone" :disabled="isReadOnly" class="phone" placeholder="请输入手机号"></el-input>
                    </el-col>
                    <!-- <el-col :span="8" class="tr">
                       <el-button :disabled="isReadOnly" type="primary"  size="small" @click="update">自动获取</el-button>
                     </el-col> -->
                </el-row>
            </el-form-item>
            <el-form-item label="留言类型:" prop="leave_message_type">
                <el-select v-model="form.leave_message_type" placeholder="请选择留言类型" :disabled="isReadOnly">
                    <el-option
                        v-for="(item, i) in leaveMessageOptions"
                        :key="i"
                        :label="item.label"
                        :value="item.value">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="问题描述:" prop="msg" class="ml-0">
                <el-input type="textarea" v-model="form.msg" :disabled="isReadOnly" resize="none" :maxlength="maxCount" show-word-limit :rows="rows" @input="checked" :class="{'unValidate': !isValidate}" @focus="inputFocus" placeholder="你好，请简短描述问题"></el-input>
            </el-form-item>
            <el-form-item label="上传附件:" class="ml-0" v-if="fileFlag=='1'">
                <el-upload :headers="headers" :action="uploadUrl" list-type="picture-card" :file-list="fileList" :on-exceed="handleExceed" :limit="9" :on-remove="handleRemove" :before-upload="beforeUpload" :on-success="handleSuccess">
                    <i class="el-icon-plus"></i>
                </el-upload>
            </el-form-item>
            <el-form-item class="ml-0">
                <el-button :type="isReadOnly ? 'info' : 'primary'" @click="submitForm()" :disabled="isReadOnly" round class="w-100">{{isReadOnly?'已提交':'提交留言'}}</el-button>
            </el-form-item>
        </el-form>
    </div>
</template>

<script>
const MAX_COUNT = 300
import authAPI from '@/api/api.js'
import message from '@/utils/message'
import delPng from '@/assets/image/del.png'

const LEAVE_MESSAGE_TYPE = {
  CONSULTATION: 1, // 咨询
  COMPLAINT: 2  // 投诉
}

export default {
    name: 'MessageBoard',
    data() {
        let validatePhone = (rule, value, callback) => {
            if (!value) {
                return callback(new Error('手机号码不能为空'))
            } else {
                let phone = value.replace(/\s/g, '')
                if (!/^1[3456789]\d{9}$/.test(phone)) {
                    return callback(new Error('请输入正确的手机号码'))
                }
                callback()
            }
        }
        return {
            headers:{
                token:''
            },
            form: {
                phone: '',
                msg: '',
                leave_message_type: 1,
            },
            fullscreenLoading: true,
            delPng: delPng,
            rules: {
                phone: [
                    {
                        required: true,
                        validator: validatePhone,
                        trigger: ['change', 'blur'],
                    },
                ],
                msg: [{ required: true, message: '问题描述不能为空' }],
                leave_message_type: [{ required: true, message: '留言类型不能为空' }],
            },
            leaveMessageOptions: [{
                label: '咨询',
                value: LEAVE_MESSAGE_TYPE.CONSULTATION,
            }, {
                label: '投诉',
                value: LEAVE_MESSAGE_TYPE.COMPLAINT,
            }],
            isReadOnly: false,
            isValidate: true,
            // options: [],
            rows: '8',
            maxCount: MAX_COUNT,
            accessType: 'mobile', //pc端 移动端
            params: '',
            saveParams:'',
            hasBack: false,
            uploadUrl: '',
            fileFlag: '0',
            fileList: [
                {
                    url:
                        process.env.VUE_APP_BASE_API +
                        '/uploads/chatRecord/2021-03-23/6059b6d47ca2e.jpg',
                },
            ],
            files: [],
        }
    },
    created() {
        document.title = '请您留言'
        this.uploadUrl =
            process.env.VUE_APP_OPEN_API + '?s=Customer.Common.Uploads'
        if (/Windows|Macintosh/i.test(navigator.userAgent)) {
            this.accessType = 'pc'
            this.rows = '5'
        } else {
            this.accessType = 'mobile'
            this.rows = '8'
        }
        if(typeof this.$route.query.token == 'string') {
            sessionStorage.setItem('token',this.$route.query.token)
            this.headers.token = this.$route.query.token
        }
        this.params = this.$route.query
        this.hasBack = this.$route.query.from && this.$route.query.from == 'H5'
        // 根据mobile参数回填手机号码
        if (this.params.mobile) {
            this.form.phone = this.params.mobile.replace(/(\d{3})(\d{4})(\d{4})/, '$1 $2 $3')
        }
        // this.getMessageType()
        this.checkMsgByCustId()
    },
    methods: {
        goBack() {
            this.$router.go('-1')
        },
        // getMessageType(){
        //     authAPI.getMessageType({'access_id': this.params.access_id}).then(res => {
        //         if(res.ret == 200){
        //             if(res.data.length > 0){
        //                 this.options = res.data.map(item => {
        //                     return {
        //                         label: item,
        //                         value: item
        //                     }
        //                 })
        //             }else{
        //                 this.options = []
        //             }
        //
        //         }
        //     })
        // },
        submitForm() {
            this.$refs['form'].validate((valid) => {
                if (valid) {
                    this.isReadOnly = true
                    this.sendLeaveMessage()
                } else {
                    return false
                }
            })
        },
        checkMsgByCustId() {
            authAPI
                .checkLeaveMessage({
                    u_cust_id: this.params.u_cust_id,
                    oid: this.params.oid,
                    session_id: this.params.session_id,
                    sign: this.params.sign
                })
                .then((res) => {
                    // file：是否开启附件（0：否，1：是）
                    if (res.ret == 200) {
                        this.fullscreenLoading = false
                        if (res.data.code == '0') {
                            this.fileFlag = res.data.file
                            this.$message.warning(res.data.msg)
                            this.isReadOnly = true
                            this.form = {
                                phone: res.data.result.phone,
                                msg: res.data.result.content,
                            }
                            this.fileList = []
                            let files = []
                            try {
                                files = JSON.parse(res.data.result.files)
                            } catch (error) {
                                files = []
                            }
                            files.forEach((item) => {
                                this.fileList.push({ url: item })
                            })
                        } else if (res.data.code == '-1') {
                            this.fileList = []
                            this.isReadOnly = true
                            message(res.data.msg)
                        } else {
                            this.fileFlag = res.data.file
                            this.fileList = []
                            this.isReadOnly = false
                        }

                      this.saveParams = res.data.data
                    } else {
                        this.isReadOnly = true
                        message(res.data.msg)
                    }

                })
                .catch(() => {
                    this.isReadOnly = false
                })
        },
        handleExceed() {
            this.$message.warning('最多上传9张图片')
        },
        handleRemove(data) {
            this.files = this.files.filter((file) => {
                return file != data.response.data.attachment
            })
        },
        beforeUpload(file) {
            if (this.isReadOnly) {
                this.$message.warning('留言已提交，禁止操作!')
                return false
            }
            const isPicture = file.type.indexOf('image/') != -1
            const isLt10M = file.size / 1024 / 1024 < 10

            if (!isPicture) {
                // eslint-disable-next-line no-mixed-spaces-and-tabs
                this.$message.error('只能上传图片!')
            }
            if (!isLt10M) {
                // eslint-disable-next-line no-mixed-spaces-and-tabs
                this.$message.error('上传图片大小不能超过 10MB!')
            }
            return isPicture && isLt10M
        },
        handleSuccess(res) {
            this.files.push(res.data.attachment)
        },
        sendLeaveMessage() {
            if (this.isReadOnly) {
                let params = {
                    u_cust_id:this.params.u_cust_id || this.saveParams.u_cust_id,
                    session_id: this.params.session_id || this.saveParams.session_id,
                    access_id: this.params.access_id || this.saveParams.access_id,
                    type: this.params.type || this.saveParams.type,
                    oid: this.params.oid || this.saveParams.oid,
                    phone: this.form.phone.replace(/\s/gi, ''),
                    content: this.form.msg,
                    files: this.files,
                    is_service: this.params.is_service || this.saveParams.is_service,
                    leave_message_type: this.form.leave_message_type,
                }
                authAPI
                    .sendLeaveMessage(params)
                    .then((res) => {
                        if (res.ret == 200) {
                            message('提交成功！请耐心等待客服人员回复')
                            this.goBack()
                            
                        } else {
                            this.isReadOnly = false
                            message(res.msg)
                        }
                    })
                    .catch(() => {
                        this.isReadOnly = false
                    })
            }
        },
        checked() {
            if (this.form.msg.length >= MAX_COUNT) {
                this.isValidate = false
                return
            }
            this.isValidate = true
        },
        update() {
            authAPI
                .getPhone({ u_cust_id: this.params.u_cust_id })
                .then((res) => {
                    if (res.ret == 200 && res.data != '') {
                        this.form.phone = res.data.replace(
                            /(\d{3})(\d{0,4})(\d{0,4})/,
                            '$1 $2 $3'
                        )
                    } else {
                        message(res.msg || '' + ' 请手动输入')
                    }
                })
                .catch(() => {})
        },
        inputFocus(event) {
            setTimeout(function () {
                let docHeight = window.innerHeight,
                    bottom = event.target.getBoundingClientRect().bottom,
                    scrollHeight = bottom - docHeight
                if (scrollHeight > 0) {
                    document.body.scrollTop =
                        scrollHeight + document.body.scrollTop + 10
                }
            }, 400)
        },
    },
    watch: {
        'form.phone'(newValue, oldValue) {
            // 监听
            if (!newValue) return
            this.form.phone =
                newValue.length > oldValue.length
                    ? newValue
                          .replace(/\s/g, '')
                          .replace(/(\d{3})(\d{0,4})(\d{0,4})/, '$1 $2 $3')
                    : this.form.phone.trim()
        },
    },
}
</script>

<style lang="stylus" scoped>
.messageBoardContainer {
    width: $width;
    height: $height;
    background: $white;
    padding: 0.532rem 0.4522rem 0.266rem 0.4522rem;
    box-sizing: border-box;
    font-size: 0.3724rem;

    .title {
        color: $title-grey;
        margin: 0;
        line-height: 0.6384rem;
        font-weight: 400;
        font-family: PingFangSC-Regular, PingFang SC;
    }

    .demo-ruleForm {
        padding-top: 0.5321rem;
    }

    .tr {
        text-align: right;
    }

    .w-100 {
        width: 100%;
    }
}

.headerTip {
    padding-bottom: 20px;
    text-align: center;
    font-size: 0.468rem;
    line-height: 0.78rem;
}

@media screen and (max-width: 924px) {
    .messageBody {
        height: calc(100vh - 40px) !important;
        width: 100vw !important;
        overflow: auto;
    }
}

@media screen and (min-width: 925px) {
    .messageBody {
        height: 86vh !important;
        width: 44vw !important;
        margin: auto !important;
        left: 28% !important;
        top: 7% !important;
        box-shadow: 0px 4px 12px 0px rgba(0, 0, 0, 0.1) !important;
        position: absolute;
        overflow: auto;
    }
}
</style>
<style lang="stylus">
.messageBoardContainer {
    .el-form-item__label, .el-form-item__content, .el-input, .el-input__inner, .el-textarea__inner {
        font-size: 0.3724rem;
        text-align: left;
    }

    .el-button {
        font-size: 0.3724rem;
    }

    .el-select {
        width: 100%;
    }

    .el-button--small {
        font-size: 0.3192rem;
        padding-left: 0.1995rem;
        padding-right: 0.1995rem;
    }

    .phone {
        .el-input__inner {
            // border 0
        }
    }

    .ml-0 {
        .el-form-item__content {
            margin-left: 0 !important;
        }
    }

    .unValidate {
        .el-input__count {
            color: #D88D8D;
        }

        .el-textarea__inner {
            border-color: #D88D8D;
        }
    }

    .el-textarea__inner {
        -webkit-appearance: none;
        transition: none;
        margin: 0;
        outline: none;
    }

    .el-input.is-disabled .el-input__inner, .el-textarea.is-disabled .el-textarea__inner {
        color: #666666 !important;
    }

    .el-upload-list--picture-card .el-upload-list__item, .el-upload--picture-card {
        width: 31%;
    }
}

.el-select-dropdown__item {
    font-size: 0.3724rem;
}

.messageBoardContainer .ml-0 .el-form-item__content {
    display: inline-block;
    width: 100%;
}
</style>